import styled, { keyframes } from 'styled-components';
import { v2Colors, v2FontFamily } from '../../formInputsV2/styles/tokens';

const orbit = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const PageLoadingStyles = styled.div`
    .content-loading {
        align-items: center;
        justify-content: center;
        min-height: 600px;
        z-index: 9000;
    }
`;

export const LoaderWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;

// A single dot orbiting a faint track, rather than a generic filled-arc
// spinner — simple (one moving element) but reads as its own thing rather
// than a stock loading icon.
export const OrbitRing = styled.div`
  position: relative;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 3px solid ${v2Colors.primarySoft};
  animation: ${orbit} 1.1s linear infinite;

  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: ${v2Colors.primary};
    box-shadow: 0 0 8px rgba(0, 166, 81, 0.55);
  }
`;

export const LoadingText = styled.p`
  margin: 0;
  font-family: ${v2FontFamily};
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${v2Colors.textMuted};
`;
